module.exports = __webpack_public_path__ + "img/wantedly-20200103.b4bb3523.jpg";